module.exports = __webpack_public_path__ + "src/assets/img/burger.34a95a2f.svg";